import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TrackMyRequestModel } from '../../../models/TrackMyRequest';
import { PatientService } from 'src/app/services/patient.service';
import { PatientDataPassService } from 'src/app/services/patient-data-pass.service';
import { PromiseResult, ServerError } from '../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { reportspdf } from 'src/app/models/reportspdf';
import { TraceClassDecorator } from '@sentry/angular';
import { LazyLoadEvent } from 'primeng';
import { consultation_status } from 'src/app/models/consultdoctors';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
    selector: 'app-track-request',
    templateUrl: './track-request.component.html',
    styleUrls: ['./track-request.component.css'
        , '../../../../assets/css/custom-egd.css'
    ]
    //   encapsulation:ViewEncapsulation.None
})
@TraceClassDecorator()
export class TrackRequestComponent implements OnInit {
    // member_value:string="";
    // Zoom_meetings: any;
    patients: any = [];
    userid: number = 0;
    consultation_status: consultation_status;
    TZ: any = Intl.DateTimeFormat().resolvedOptions().timeZone;
    displayedColumns: string[] = [
        'consultation_request_number',
        'date',
        'consultation_type',
        'priority_type',
        'speciality_name',
        'Doctor',
        'consultation_status',
        'Appointment_date',
        'communication_name',
        'Document_status',
        'consultations_left'
    ];
    members_list: any = [];
    member_value;
    selectedMember: any;
    posting: boolean;
    response: PromiseResult;
    serverError: ServerError;
    consultation_id: number = 0;
    patient_guid: string = '';
    displayModel1: boolean = false;
    slug: string = "";
    showDoctorReports: string = 'showDoctorReports';
    printContent: string = 'print-content';
    doctorReportsData: reportspdf;
    doctorReportsSuccess: boolean = null;
    constructor(
        private readonly breadcrumbService: BreadcrumbService,
        private readonly titleService: Title,
        private readonly router: Router,
        private readonly patientservice: PatientService,
        private readonly patientData: PatientDataPassService,
        private readonly providerStateService: ProviderStateService
    ) {

        this.posting = false;
    }

    async ngOnInit() {
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
            { label: 'Track Request' }
        ]);
        await this.ResetResultModels();
        await this.getMemberList();
        this.SetTitle('Dashboard - Track Request');
    }

    request: TrackMyRequestModel[];

    SetTitle(title: string) {
        this.titleService.setTitle(title);
    }
    async onMemberChange(patientValue): Promise<void> {
        this.member_value = patientValue;
        await this.getRequests(null);
    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async getMemberList() {
        let temp = [];
        await this.ResetResultModels();
        this.posting = true;
        await this.patientservice
            .getMember(sessionStorage.getItem('userid'))
            .toPromise()
            .then((result) => {
                if (result.success) {
                    for (let i = 0; i < result.data.patient.length; i++) {
                        temp.push({
                            label:
                                ' ' +
                                result.data.patient[i].first_name +
                                ' ' +
                                (result.data.patient[i].middle_name == null ? '' : result.data.patient[i].middle_name) +
                                ' ' +
                                result.data.patient[i].last_name +
                                ' ',
                            value: result.data.patient[i].patient_guid
                        });
                    }
                    this.members_list = temp;
                } else {
                    this.response = result;
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
    }
    async getRequests(event: LazyLoadEvent): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.patientservice
            .getMyRequest(this.member_value)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.request = [];
                    this.userid = 0;
                    let ans: TrackMyRequestModel[] = [];
                    let data = result.data;
                    for (let i = 0; i < data.length; i++) {
                        ans.push({
                            id: data[i].id,
                            consultation_request_number:
                                data[i].consultation_request_number,
                            name:
                                data[i].accounts.first_name +
                                ' ' +
                                data[i].accounts.last_name,
                            date: data[i].created_at,
                            consultation_type:
                                data[i].consultation_type.consultation_name,
                            priority_type: data[i].priority_type.priority_type || 'N/A',
                            specialty_name: data[i].p_consultation_appointment.map(d => {
                                return d.d_specialty_type.specialty_name;
                            }),
                            Document_status: 0,
                            Doctor:
                                data[i].consultation_date == null ?
                                    ['TBA'] : data[i].p_consultation_appointment.map(d => {
                                        return d.egd_users.first_name + ' ' + d.egd_users.last_name;
                                    }),
                            consultation_status: data[i].consultation_status,
                            Appointment_date:
                                data[i].consultation_date,
                            communication_name:
                                data[i].communication_type.communication_name,
                            communication_id: data[i].communication_type.id,
                            Zoom_meetings:
                                data[i].zoom_meetings != null &&
                                    new Date(
                                        new Date(data[i].consultation_date).getTime() + 15 * 60000
                                    ) > new Date()
                                    ? data[i].zoom_meetings.join_url
                                    : '',
                            change: false,
                            consultations_left: data[i].consultations_left == 0 ? 'N/A' : data[i].consultations_left,
                        });
                    }
                    this.request = ans;
                    ans = [];
                } else {
                    this.response = result;
                }

                this.posting = false;
            })
        // .catch((error: HttpErrorResponse) => {
        //     this.serverError = error.error;
        //     this.response.success = false;
        //     this.posting = false;
        // });
    }

    gotoEditDocs(member_value) {
        this.patientData.setID(member_value);
        this.RouterNavigation('uploadandeditdocuments');
    }
    print() {
        window.print();
    }

    private async GetDoctorReportsData() {
        await this.patientservice
            .GetDoctorReportspdf(
                this.patient_guid,
                this.consultation_id,
                'report'
            )
            .toPromise()
            .then((result) => {
                this.doctorReportsSuccess = result.success;
                if (result.success) {
                    this.response = result;
                    this.doctorReportsData = result.data;
                }
            });
    }

    async gotoReportpdf(consultation_id: number) {
        this.patient_guid = this.member_value;
        this.consultation_id = consultation_id;

        await this.GetDoctorReportsData();
        this.displayModel1 = true;
        //  window.open('/doctorreportpdf','_blank');
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/patient/' + path]);
    }
    async CloseDialog(): Promise<void> {
        this.displayModel1 = false;
    }
}
